<!-- Menu Circle Small -->
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" overflow="visible">
    <circle cx="12" cy="12" r="12" class="secondary-fill" stroke="none" fill="none"/>
    <circle cx="12" cy="12" r="11.5" class="primary-stroke" fill="none"/>
    <path class="primary-fill" d="M12 9a1.5 1.5 0 111.5-1.5A1.5 1.5 0 0112 9zm0 4.5a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5zm0 4.5a1.5 1.5 0 111.5-1.5A1.5 1.5 0 0112 18z"/>
</svg>
